// extracted by mini-css-extract-plugin
export default {"slotCode":"SlotCode_slotCode__CmAum"};